export default __webpack_public_path__ + "static/media/Spin general_Interactive LightMix0071.4e0b5409.webp";